/* eslint-disable import/prefer-default-export */
export const X_REQUESTED_BY = 'X-Requested-By';
